module.exports = __webpack_public_path__ + "img/facilityInfo_1_0.b7314a18.jpg";